import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useLoading } from "../contexts/LoadingContext";

const GlobalSpinner = () => {
  const { loading } = useLoading();

  return (
    loading && (
      <div className="global-spinner">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  );
};

export default GlobalSpinner;
